<template>
    <TItems
        class="o-d-services d-services"
        :footerButton="footerButtonTheme"
        :footer-button-text="footerButtonText"
        @clickFooterButton="handleFooterClick"
    >
        <template #header>
            <OWItemsHeader
                :title="$t('ui.service-category')"
                :subtitle="$t('ui.service-category.description')"
                color="#E25046"
            >
                <template #left>
                    <svg-icon
                        original
                        name="icons/services"
                        class="d-services__icon"
                    />
                </template>
                <template #right>
                    <ACloseButton
                        @onClick="handleCloseClick"
                    />
                </template>
            </OWItemsHeader>
        </template>
        <template #main>
            <RecycleScroller
                #default="{ item }"
                :items="sortedItems"
                :item-size="79"
                class="o-d-services__scroller"
            >
                <OWServicesTile
                    :item="item"
                    @onClick="handleTileClick"
                />
            </RecycleScroller>
        </template>
    </TItems>
</template>

<script>
import { mapGetters } from 'vuex';

import TItems from '../../templates/t-items/t-items';
import ACloseButton from '../../atoms/a-close-button/a-close-button';
import OWItemsHeader from '../../organisms/o-w-items-header/o-w-items-header';
import OWServicesTile from '../../organisms/o-w-services-tile/o-w-services-tile';

import webItemFunctionality from '../../../utils/mixins/web-items-functionality';
import firstElementTabNavigation from '../../../utils/mixins/first-element-tab-navigations';
import { WEB_SERVICE } from '../../../utils/constants/pages';

export default {
    name: 'ODServices',
    components: {
        TItems,
        ACloseButton,
        OWItemsHeader,
        OWServicesTile
    },
    mixins: [
        webItemFunctionality,
        firstElementTabNavigation
    ],
    data() {
        return {
            tabNavigationStartElement: '.o-w-services-tile'
        }
    },
    props: {
        guide: {
            type: Boolean,
            default: false
        },
        filteredByItem: {
            type: Number,
            default: null
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getServiceCategories',
            'getObject'
        ]),
        service() {
            return this.getObject(this.filteredByItem);
        },
        sortedItems() {
            const items = [...this.getServiceCategories];
            if (this.filteredByItem && this.service.type === 'service' || this.filteredByItem && this.service.lists['service_categories']) {
                const filtered = [];
                items.forEach(item => {
                    if (this.service.lists.categories ? this.service.lists.categories.includes(item.id) : this.service.lists['service_categories'].includes(item.id)) {
                        if (item.objectsCount > 1) {
                            item.objectsCount -= 1;
                            filtered.push(item);
                        }
                    } else {
                        filtered.push(item);
                    }
                });
                return filtered.sort((a, b) => this.t(a, 'name').localeCompare(this.t(b, 'name'), 'sv'));
            } else {
                return items.sort((a, b) => this.t(a, 'name').localeCompare(this.t(b, 'name'), 'sv'));
            }
        }
    },
    methods: {
        handleTileClick(data) {
            if (this.guide) {
                this.$emit('onTileClick', data);
            } else {
                console.log('tile' + data);
                const params = {
                    name: WEB_SERVICE,
                    query: {
                        id: data.id
                    }
                };
                this.$router.push(params);
            }
        }
    }
}
</script>

<style lang="scss">
@import "o-d-services";    
</style>